export const defaultGroup = {
    id: undefined,
    tenantId: '',
    groupName: '',
    groupType: '',
    active: false
};
export const groups = {
    defaultGroup
};
